/* global axios */
import PublicApiClient from './PublicApiClient';

class CampaignPublicAPI extends PublicApiClient {
  constructor() {
    super('campaign_forms', { accountScoped: true });
  }

  fetchCampaignFormBySlug(slug, params = {}) {
    return axios.get(`${this.url}/${slug}`, { params });
  }

  createCampaignFormResponse(slug, payload) {
    return axios.post(`${this.url}/${slug}/form_responders`, payload);
  }
}

export default new CampaignPublicAPI();
